import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_imagemaint } from "../shared/data.service";

import { wsImageLibraryListInfo } from "../shared/wsImageLibraryListInfo";
import { wsImageLibraryEditInfo } from "../shared/wsImageLibraryEditInfo";
import { wsImageLibraryEditUpdateInfo } from "../shared/wsImageLibraryEditUpdateInfo";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper"; // https://github.com/Mawi137/ngx-image-cropper

@Component({
	selector: "app-root",
	templateUrl: "./imageedit.component.html",
	styleUrls: ["./imageedit.component.css"],
})
export class ImageEditComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_imagemaint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isLoaded: boolean = false;
	public SelectedSchool: any;

	public SelectedImageLibraryItem: wsImageLibraryListInfo;

	public cropperImageBase64: any = "";
	public cropperCroppedImage: any = "";
	public cropperCroppedWorkImage: any = "";
	public cropperMaintainAspectRatio: boolean = false;
	public cropperAspectRatio: number = 1.0;
	public cropperCanvasRotation: number = 0.0;
	public cropperTransform: ImageTransform = {};

	public isCustom: boolean = true;
	public isLandscape: boolean = false;
	public isPortrait: boolean = false;

	public filterGrayscale: boolean = false;
	public filterBrightness: number = 0.0;
	public filterContrast: number = 0.0;

	// https://www.html5rocks.com/en/tutorials/canvas/imagefilters/

	//	Image Processing
	private rImageEditUpdate: wsImageLibraryEditUpdateInfo[] = [];

	public ImageLibraryEdit: wsImageLibraryEditInfo = {
		ImageLibraryID: "",
		ImageData_Normal: "",
		ImageData_Raw: "",
	};

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.SelectedImageLibraryItem = this.dialogConfig.data.SelectedItem;

		//
		//	Get The Photo To Edit From CAASS or Staging Queue
		//
		let parms: wsImageLibraryEditInfo = {
			ImageLibraryID: this.SelectedImageLibraryItem.ImageLibraryID,
			ImageData_Normal: "",
			ImageData_Raw: "",
		};

		this.dataService.ImageLibraryEditGet(parms).subscribe((data) => this.ImageLibraryEditGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------

	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryEditGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryEditGet_Complete(data: any) {
		this.isLoaded = true;
		this.ImageLibraryEdit = data;

		this.cropperImageBase64 = this.ImageLibraryEdit.ImageData_Normal;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCustom
	//
	//-----------------------------------------------------------------------------------------------------
	onCustom() {
		this.isCustom = true;
		this.isPortrait = false;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = false;
		this.cropperAspectRatio = 1.0 / 1.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPortrait
	//
	//-----------------------------------------------------------------------------------------------------
	onPortrait() {
		this.isCustom = false;
		this.isPortrait = true;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 3.0 / 4.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onLandscape
	//
	//-----------------------------------------------------------------------------------------------------
	onLandscape() {
		this.isCustom = false;
		this.isPortrait = false;
		this.isLandscape = true;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 4.0 / 3.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRotateCanvas
	//
	//-----------------------------------------------------------------------------------------------------
	onRotateCanvas() {
		let newRotation = this.cropperCanvasRotation + 1; // 0=0°, 1=90°, 2=180°, 3=270°

		if (newRotation > 3) {
			newRotation = 0;
		}

		this.cropperCanvasRotation = newRotation;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageH
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageH() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipH: !this.cropperTransform.flipH,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageV
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageV() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipV: !this.cropperTransform.flipV,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRestore
	//
	//-----------------------------------------------------------------------------------------------------
	onRestore() {
		this.cropperImageBase64 = this.ImageLibraryEdit.ImageData_Raw;
		this.filterGrayscale = false;
		this.filterBrightness = 0;
		this.filterContrast = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExport
	//
	//-----------------------------------------------------------------------------------------------------
	onExport() {
		const MAX_SIZE = 640;
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let ExportImage: any = canvas.toDataURL("image/jpeg");

			const dlink: HTMLAnchorElement = document.createElement("a");
			dlink.download = "CAASSImage.jpg"; // the file name
			dlink.href = ExportImage;
			dlink.click(); // this will trigger the dialog window
			dlink.remove();
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageLoaded
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageLoaded(image: any) {
		this.isLoaded = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperReady
	//
	//-----------------------------------------------------------------------------------------------------
	cropperReady() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperLoadImageFailed
	//
	//-----------------------------------------------------------------------------------------------------
	cropperLoadImageFailed() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageCropped
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageCropped(event: ImageCroppedEvent) {
		var ImgData = "";

		if (event.base64 != undefined) {
			ImgData = event.base64;
		} else if (event.objectUrl != undefined) {
			ImgData = event.objectUrl;
		}
		this.cropperCroppedImage = ImgData;
		this.cropperCroppedWorkImage = ImgData;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setGrayscaleValue
	//
	//-----------------------------------------------------------------------------------------------------
	setGrayscaleValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setBrightnessValue
	//
	//-----------------------------------------------------------------------------------------------------
	setBrightnessValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setContrastValue
	//
	//-----------------------------------------------------------------------------------------------------
	setContrastValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyFilters
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyFilters() {
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let canvas = document.createElement("canvas");

			canvas.width = img.width;
			canvas.height = img.height;

			let ctx = canvas.getContext("2d");

			ctx!.drawImage(img, 0, 0);

			let imageData = ctx!.getImageData(0, 0, Number(img.width), Number(img.height));
			let data = imageData.data;

			if (_this.filterGrayscale == true) {
				_this.applyGrayscale(data);
			}
			_this.applyBrightness(data, _this.filterBrightness);
			_this.applyContrast(data, _this.filterContrast);

			ctx!.putImageData(imageData, 0, 0);

			_this.cropperCroppedWorkImage = canvas.toDataURL("image/jpeg");
		};

		img.src = this.cropperCroppedImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyGrayscale
	//
	//-----------------------------------------------------------------------------------------------------
	applyGrayscale(data: any) {
		var d = data;
		for (var i = 0; i < d.length; i += 4) {
			var r = d[i];
			var g = d[i + 1];
			var b = d[i + 2];
			// CIE luminance for the RGB
			// The human eye is bad at seeing red and blue, so we de-emphasize them.
			var v = 0.2126 * r + 0.7152 * g + 0.0722 * b;
			d[i] = d[i + 1] = d[i + 2] = v;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyBrightness
	//
	//-----------------------------------------------------------------------------------------------------
	applyBrightness(data: any, brightness: number) {
		for (var i = 0; i < data.length; i += 4) {
			data[i] += 255 * (brightness / 100);
			data[i + 1] += 255 * (brightness / 100);
			data[i + 2] += 255 * (brightness / 100);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyContrast
	//
	//-----------------------------------------------------------------------------------------------------
	applyContrast(data: any, contrast: number) {
		var factor = (259.0 * (contrast + 255.0)) / (255.0 * (259.0 - contrast));

		for (var i = 0; i < data.length; i += 4) {
			data[i] = this.truncateColor(factor * (data[i] - 128.0) + 128.0);
			data[i + 1] = this.truncateColor(factor * (data[i + 1] - 128.0) + 128.0);
			data[i + 2] = this.truncateColor(factor * (data[i + 2] - 128.0) + 128.0);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onBrightnessReset
	//
	//-----------------------------------------------------------------------------------------------------
	onBrightnessReset() {
		this.filterBrightness = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onContrastReset
	//
	//-----------------------------------------------------------------------------------------------------
	onContrastReset() {
		this.filterContrast = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	truncateColor
	//
	//-----------------------------------------------------------------------------------------------------
	truncateColor(value: number) {
		if (value < 0) {
			value = 0;
		} else if (value > 255) {
			value = 255;
		}

		return value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSave
	//
	//-----------------------------------------------------------------------------------------------------
	onSave() {
		this.ResizeImageAndUpload();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndUpload() {
		const MAX_SIZE = 640;

		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let obj: wsImageLibraryEditUpdateInfo = {
				ImageLibraryID: _this.SelectedImageLibraryItem.ImageLibraryID,
				ImageData_Normal: canvas.toDataURL("image/jpeg"),
			};

			_this.rImageEditUpdate.push(obj);

			//
			//	Upload Edited Image
			//
			console.log("Starting image edit upload..", new Date().toLocaleTimeString("en-US"));
			_this.dataService.ImageLibraryEditUpdate(_this.rImageEditUpdate[0]).subscribe((data) => _this.ImageLibraryEditUpdate_Callback(data));
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryEditUpdate_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryEditUpdate_Callback(data: any) {
		console.log("Image edit upload complete..", new Date().toLocaleTimeString("en-US"));
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
